__turbopack_context__.v({
  "BaseTable": "BaseTable-module__dECyQG__BaseTable",
});
